// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны

export interface IButtonSchema {
  /** Действие кнопки **/
  action: EAction;
  /** Отключена ли кнопка **/
  disabled?: boolean;
  /** Текст кнопки **/
  text: string;
  /** Тема/стиль кнопки **/
  theme: ETheme;
}
export enum EAction {
  /** Откликнуться на вакансию **/
  'Apply' = 'apply',
  /** Рекомендовать кандидата на вакансию **/
  'Recommend' = 'recommend',
}
export enum ETheme {
  /** Основная тема кнопки **/
  'Primary' = 'primary',
  /** Второстепенная тема кнопки **/
  'Secondary' = 'secondary',
}
